'use client';

import { cn } from '@/lib/cn';
import { useRef } from 'react';
import type { AriaTimeFieldProps, TimeValue } from 'react-aria';
import { useLocale, useTimeField } from 'react-aria';
import { useTimeFieldState } from 'react-stately';
import { DateSegment } from './date-segment';

function TimeField(props: AriaTimeFieldProps<TimeValue>) {
  const ref = useRef<HTMLDivElement | null>(null);

  const { locale } = useLocale();
  const state = useTimeFieldState({
    ...props,
    locale,
  });
  const {
    fieldProps: { ...fieldProps },
  } = useTimeField({ 'aria-label': 'Tid', ...props }, state, ref);

  return (
    <div
      {...fieldProps}
      ref={ref}
      className={cn(
        'inline-flex h-11 w-full flex-1 items-center rounded-input border border-input bg-transparent px-4 py-2 text-sm focus-within:border-ring focus-within:ring-[3px] focus-within:ring-ring/50 focus-visible:outline-hidden',
        props.isDisabled ? 'cursor-not-allowed opacity-50' : ''
      )}
    >
      {state.segments.map((segment, i) => (
        <DateSegment key={i} segment={segment} state={state} />
      ))}
    </div>
  );
}

export { TimeField };
